/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    expanded: {
      marginTop: "0 !important",
      marginBottom: "0 !important",
      height: 'auto !important',
    },
    root: {
      boxSizing: 'content-box',
      display: "flex",
      flex: "1",
      flexDirection: "column",
      boxShadow: "none",
      padding: theme.spacing(3),
      backgroundColor: theme.palette.common.white,
      marginTop: "0",
      "&~&": {
        marginLeft: theme.spacing(2)
      },
      '&::before': {
        display: 'none'
      }
    },
    categoryBody: {
      display: "flex",
      flexDirection: "column",
      padding: 0,
      boxSizing: 'content-box',
      height: '100%',
    },
    categoryTitle: {
      fontWeight: 'bold' as any,
      fontSize: '14px',
      lineHeight: '20px',
      color: theme.palette.common.black,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      '& > div': {
        display: 'flex',
        alignItems: 'center',
      }
    },
    categoryTitleIcon: {
      width: '28px',
      height: '28px',
      marginRight: theme.spacing(2)
    }
  });

export const useStyles = makeStyles(styles);
